// These are ported from monolith /inc/constants.php
// Please keep these files synced if making changes
import { TYPES } from '@/generated/graphql';
import { type ValueOf } from '@/types/utils';

export const Action = {
	ANY: 'any',
	MODIFY: 'modify',
	CREATE: 'create',
	COPY: 'copy',
	PRINT: 'print',
	VIEW: 'view',
	DELETE: 'delete',
	RESTORE: 'restore',
	SEND: 'send',
	DOWNLOAD: 'download',
	ACTIVATE: 'activate',
	DEACTIVATE: 'deactivate',
	EXPORT: 'export',
	LIST: 'list',
	TEMPLATES: 'templates',
	BULK_CHANGE: 'bulk',
	SAVE_PDF: 'pdf',
	BOARD_VIEW: 'boardView',
	EMBED: 'embed',
	LOGS: 'logs',
};

export const KeyboardKey = {
	ENTER: 'Enter',
	ARROW_UP: 'ArrowUp',
	ARROW_DOWN: 'ArrowDown',
	ARROW_LEFT: 'ArrowLeft',
	ARROW_RIGHT: 'ArrowRight',
	BACKSPACE: 'Backspace',
	DELETE: 'Delete',
	SPACE: 'Space',
	TAB: 'Tab',
	ESC: 'Escape',
} as const;

export const FinanceDocumentEntities: Array<ValueOf<typeof TYPES>> = [
	TYPES.Invoice,
	TYPES.Order,
	TYPES.Quote,
	TYPES.RentalOrder,
	TYPES.Expense,
	TYPES.PurchaseOrder,
	TYPES.Bill,
];

export const DEFAULT_AUTO_SUGGEST_LIMIT = 50;

export const HelpStationQueryParams = {
	HELP_STATION_CLOSE_QUERY_PARAM: 'close_help_station',
};

export const SELF_SERVICE_CHANGES_SAVED = 'selfServiceChangesSaved';

export const SyncActions = {
	SYNC_ACTION_VIEW_IN_EXTERNAL: 'viewInExternal',
	SYNC_ACTION_SEND_TO_EXTERNAL: 'sendToExternal',
	SYNC_ACTION_FETCH_FROM_EXTERNAL: 'fetchFromExternal',
	SYNC_ACTION_FETCH_PAYMENTS_FROM_EXTERNAL: 'fetchPaymentsFromExternal',
	SYNC_ACTION_PRINT_INVOICE: 'printExternalInvoice',
	SYNC_ACTION_DELETE_FROM_EXTERNAL: 'deleteFromExternal',
	SYNC_ACTION_UNLINK_OBJECT_FROM_EXTERNAL: 'unlinkObjectFromExternal',
	SYNC_ACTION_SHOW_ERRORS: 'showErrors',
	SYNC_ACTION_SEND_FILES_TO_EXTERNAL: 'sendFilesToExternal',
	SYNC_ACTION_FETCH_FILES_FROM_EXTERNAL: 'fetchFilesFromExternal',
	SYNC_ACTION_SHOW_SYNC_DATA: 'showSyncData',
} as const;

export const USER_INVITE_POPUP_OPEN_QUERY_PARAM = 'open_user_invite_popup';
export const USER_INVITE_POPUP_FIRST_TIME_QUERY_PARAM =
	'user_invite_first_time_flow';
export const USER_PLACEHOLDER_IMAGE =
	'https://scoroassets.scoro.com/gfx/placeholder.svg';

export const STRIPE_BANNER_CLICKED_QUERY_PARAM = 'show_stripe_tour';

export const VERSION_STATE_BETA = 'beta';

export const GetStartedActionCards = {
	DELETE_DEMO_DATA: 'delete_demo_data',
};

export const DEFAULT_HTML_SANITIZE_ALLOWED_TAGS = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'a',
	'b',
	'i',
	'em',
	'b',
	'strong',
	'br',
	'p',
	'h3',
	'q',
	'div',
	'span',
	'img',
	'ul',
	'ol',
	'li',
	'pre',
	'table',
	'tr',
	'td',
	'th',
	'tbody',
	'thead',
	'blockquote',
];

export const DEFAULT_HTML_SANITIZE_OPTIONS = {
	allowedAttributes: {
		div: ['class'],
		span: ['style', 'class'],
		a: ['href', 'target'],
		img: ['src'],
	},
};

export const AvailabilityThresholds = {
	OVERBOOKED: 1.0,
	LIGHTLY_OVERBOOKED: 1.19,
	HEAVY_OVERBOOKED: 1.39,
};
